import { render, staticRenderFns } from "./PresentationCenter.vue?vue&type=template&id=9be569f6&scoped=true&"
import script from "./PresentationCenter.vue?vue&type=script&lang=js&"
export * from "./PresentationCenter.vue?vue&type=script&lang=js&"
import style0 from "./PresentationCenter.vue?vue&type=style&index=0&id=9be569f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be569f6",
  null
  
)

export default component.exports